import { Box, Typography } from "@mui/material";

import HeroBanner from "../HeroBanner";
import NewStarterProgress from "./NewStarterProgress";
export default function FormSection({
    starterData,
    currentStep,
    steps,
    children
}) {

    return (
        <>
            <HeroBanner
                title={`Welcome to the team, ${starterData.firstName}!`}
                subtitle="New Starter Form"
                subtitle2="Please complete all sections of the form before submitting."
            />
            <NewStarterProgress
                currentStep={currentStep}
                steps={steps}
            />

                {children}

        </>
    );
}